import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';

import { authActions } from '../../redux/slices/authSlice';
import { useAppDisPatch } from '../../redux/store';
import { ACCOUNT, SIGNIN } from '../../routes/routeConstants';

const useOnRefreshScreen = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useAppDisPatch();

  const onRefreshScreen = useCallback(() => {
    const data = localStorage.getItem('authData');
    try {
      if (data) {
        const authData = JSON.parse(data);
        // if (!authData.user.verified) {
        //   setLoading(false);
        //   navigate(`/${ACCOUNT}/${CHANGE_PASSWORD}`, {
        //     // replace: true,
        //     state: { data: authData.user },
        //   });
        // }
        setLoading(false);
        dispatch(
          authActions.setAuthentication({ authData, isAuthenticated: true })
        );
      } else {
        setLoading(false);
        navigate(`/${ACCOUNT}/${SIGNIN}`, { replace: true });
      }
    } catch {
      navigate(`/${ACCOUNT}/${SIGNIN}`, { replace: true });
    }
    // eslint-disable-next-line
  }, []);

  return {
    onRefreshScreen,
    loading,
  };
};

export default useOnRefreshScreen;
